import classNames from 'classnames'
import React, { ReactNode } from 'react'
import styles from './index.module.css'

export interface PageHeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  rightContainer?: ReactNode
  backButton?: ReactNode
  linkElement?: ReactNode
}

export const PageHeading = ({
  className,
  children,
  rightContainer,
  backButton,
  linkElement,
  ...props
}: PageHeadingProps) => (
  <div className="flex justify-between items-center">
    <h1 className={classNames(className, styles.h4)} {...props}>
      {backButton}
      <span className={styles.text}>{children}</span>
      <span className="text-sm">{linkElement}</span>
    </h1>
    {rightContainer}
  </div>
)
